import { useTranslation } from 'react-i18next';

import './Home.css';
import SwitchNavigation from '../translations/SwitchNavigation';

import Cal from './icons/cal.svg';
import Facebook from './icons/facebook.svg';
import Github from './icons/github.svg';
import Gmail from './icons/gmail.svg';
import Linkedin from './icons/linkedin.svg';
import Stackoverflow from './icons/stackoverflow.svg';
import Telegram from './icons/telegram.svg';
import Twitter from './icons/twitter.svg';
import Vk from './icons/vk.svg';
import WhatsApp from './icons/whatsapp.svg';

export function Home() {
  const { t } = useTranslation();

  return (
    <div className="centered">
      <SwitchNavigation />
      <div className="main">
        <div className="row">
          <div>{t('home.hi_there')}</div>
          <div>{t('home.description')}</div>
          <div>{t('home.who_am_i')}</div>
        </div>
        <div className="row">
          <a href={t('home.cv.link')}>{t('home.cv.description')}</a>
        </div>
        <div className="row">
          <a href="https://github.com/framebassman" data-testid="github">
            <img src={Github} className="icon" />
          </a>
          <a
            href="https://stackoverflow.com/users/2777349/dmitry-romashov"
            data-testid="stackoverflow"
          >
            <img src={Stackoverflow} className="icon" />
          </a>
          <a href="https://twitter.com/frame_bassman">
            <img src={Twitter} className="icon" />
          </a>
          <a href="https://vk.com/framebassman">
            <img src={Vk} className="icon" />
          </a>
          <a href="https://www.facebook.com/framebassman">
            <img src={Facebook} className="icon" />
          </a>
          <a href="https://wa.me/+79995379788">
            <img src={WhatsApp} className="icon" />
          </a>
          <a href="https://t.me/framebassman">
            <img src={Telegram} className="icon" />
          </a>
          <a href="https://www.linkedin.com/in/dmitry-romashov-124a64a8">
            <img src={Linkedin} className="icon" />
          </a>
          <a href="mailto:framebassman@gmail.com">
            <img src={Gmail} className="icon" />
          </a>
          <a href="https://cal.com/framebassman">
            <img src={Cal} className="icon" />
          </a>
        </div>
      </div>
    </div>
  );
}
